import * as pdfjsLib from "pdfjs-dist"

import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry"

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

const extractTextFromPDF = async (file) => {
  const arrayBuffer = await file.arrayBuffer()
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise

  let fullText = ""
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i)
    const content = await page.getTextContent()
    const pageText = content.items.map((item) => item.str).join(" ")
    fullText += pageText + "\n"
  }

  return {
    text: fullText,
    pageCount: pdf.numPages,
  }
}

export default extractTextFromPDF
